var VGSEndpoints;
(function (VGSEndpoints) {
    VGSEndpoints["GetSensitiveCardInfo"] = "/cards/get-sensitive-card-info";
    VGSEndpoints["GetSensitiveCardInfoAfterApproval"] = "/cards/get-sensitive-card-info-after-approval";
})(VGSEndpoints || (VGSEndpoints = {}));
export { VGSEndpoints, };
